import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";

export default function TimelineExplorer() {
  const [activeId, setActiveId] = useState(articles[0].id);
  const active = articles.find((item) => item.id === activeId) ?? articles[0];

  return (
    <section id="timeline" className="mx-auto max-w-content scroll-mt-24 px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="TIMELINE"
        title="事件时间线速览"
        description="挑一个事件，直接看它从起点到收尾的关键节点。顺序对了，因果自然就清楚了。"
      />

      <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="flex flex-col gap-2 rounded-lg border border-background-200/70 bg-background-100 p-3">
            <p className="px-3 py-2 text-xs tracking-[0.22em] text-foreground-500">选择事件</p>
            {articles.slice(0, 6).map((item) => {
              const isActive = item.id === activeId;
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => setActiveId(item.id)}
                  aria-pressed={isActive}
                  className={`flex items-center justify-between gap-3 rounded-md px-3 py-3 text-left transition-colors duration-200 cursor-pointer ${
                    isActive
                      ? "bg-primary-800/70 text-foreground-950"
                      : "text-foreground-700 hover:bg-background-200/60"
                  }`}
                >
                  <span className="line-clamp-2 text-sm leading-snug">{item.title}</span>
                  <i
                    className={`shrink-0 text-base ${
                      isActive ? "ri-record-circle-line text-accent-400" : "ri-circle-line text-foreground-600"
                    }`}
                  />
                </button>
              );
            })}
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="rounded-lg border border-background-200/70 bg-background-100 p-5 md:p-7">
            <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200/70 pb-5">
              <div>
                <p className="text-xs text-accent-500">{active.categoryName}</p>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
                  {active.title}
                </h3>
              </div>
              <span className="rounded-full border border-background-300/70 px-3 py-1 text-xs text-foreground-600">
                {active.timeline.length} 个节点
              </span>
            </div>

            <ol className="relative mt-6 space-y-6 border-l border-background-300/60 pl-6">
              {active.timeline.map((node) => (
                <li key={`${active.id}-${node.date}`} className="relative">
                  <span className="absolute -left-[31px] top-1.5 h-2.5 w-2.5 rounded-full bg-accent-500 ring-4 ring-background-100" />
                  <p className="font-heading text-xs tracking-wide text-accent-400">{node.date}</p>
                  <p className="mt-1.5 font-heading text-[15px] font-semibold text-foreground-900">
                    {node.title}
                  </p>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{node.desc}</p>
                </li>
              ))}
            </ol>

            <Link
              to={`/article/${active.id}`}
              className="group mt-7 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-950 transition-colors duration-200 hover:bg-accent-400 cursor-pointer"
            >
              阅读完整复盘
              <i className="ri-arrow-right-line transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}